<template>
  <div class="p-4">
    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col-12 text-left">
            <h4>System settings</h4>
          </div>
        </div>
      </div>
      <div class="card-body">
        <form v-on:submit.prevent="fnUpdate">
          <div class="row">
            <div class="col-xl-4 col-lg-4 col-md-4 col-12">
              <div class="form-group">
                <input
                  class="form-control"
                  type="text"
                  autocomplete="off_companyName"
                  placeholder=" "
                  v-model="userData.companyName"
                />
                <label class="floatingLabel" for="companyName"
                  >Company name
                </label>
                <div class="invalid-feedback" v-if="errors.companyName">
                  {{ errors.companyName[0] }}
                </div>
              </div>
              <div class="form-group">
                <input
                  class="form-control"
                  type="text"
                  autocomplete="off_street"
                  placeholder=" "
                  v-model="userData.street"
                />
                <label class="floatingLabel" for="street">Street </label>
                <div class="invalid-feedback" v-if="errors.street">
                  {{ errors.street[0] }}
                </div>
              </div>
              <div class="form-group">
                <input
                  class="form-control"
                  type="text"
                  autocomplete="off_suburb"
                  placeholder=" "
                  v-model="userData.suburb"
                />
                <label class="floatingLabel" for="suburb">Suburb </label>
                <div class="invalid-feedback" v-if="errors.suburb">
                  {{ errors.suburb[0] }}
                </div>
              </div>
              <div class="form-group">
                <b-form-select
                  plain
                  autocomplete="off_state"
                  placeholder=" "
                  :options="optionsStates"
                  value-field="code"
                  text-field="name"
                  v-model="userData.state"
                ></b-form-select>
                <label class="floatingLabel" for="state">State</label>
                <div class="invalid-feedback" v-if="errors.state">
                  {{ errors.state[0] }}
                </div>
              </div>
              <div class="form-group">
                <input
                  class="form-control"
                  type="text"
                  autocomplete="off_postCode"
                  placeholder=" "
                  v-model="userData.postCode"
                />
                <label class="floatingLabel" for="postCode">Post code </label>
                <div class="invalid-feedback" v-if="errors.postCode">
                  {{ errors.postCode[0] }}
                </div>
              </div>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-4 col-12">
              <div class="form-group">
                <input
                  class="form-control"
                  type="text"
                  autocomplete="off_phoneNo"
                  placeholder=" "
                  v-model="userData.phoneNo"
                />
                <label class="floatingLabel" for="phoneNo">Phone no </label>
                <div class="invalid-feedback" v-if="errors.phoneNo">
                  {{ errors.phoneNo[0] }}
                </div>
              </div>
              <div class="form-group">
                <input
                  class="form-control"
                  type="text"
                  autocomplete="off_companyEmail"
                  placeholder=" "
                  v-model="userData.companyEmail"
                />
                <label class="floatingLabel" for="companyEmail">Email </label>
                <div class="invalid-feedback" v-if="errors.companyEmail">
                  {{ errors.companyEmail[0] }}
                </div>
              </div>
              <div class="form-group">
                <input
                  class="form-control"
                  type="text"
                  autocomplete="off_abn"
                  placeholder=" "
                  v-model="userData.abn"
                />
                <label class="floatingLabel" for="firstName">ABN </label>
              </div>
              <div class="form-group">
                <input
                  class="form-control"
                  type="text"
                  autocomplete="off_vsaDefaultEmail"
                  placeholder=" "
                  v-model="userData.vsaDefaultEmail"
                />
                <label class="floatingLabel" for="vsaDefaultEmail"
                  >VSA default email
                </label>
                <div class="invalid-feedback" v-if="errors.vsaDefaultEmail">
                  {{ errors.vsaDefaultEmail[0] }}
                </div>
              </div>
            </div>

            <div class="col-xl-4 col-lg-4 col-md-4 col-12">
              <div class="form-group">
                <input
                  class="form-control"
                  type="text"
                  autocomplete="off_fbtBaseValue"
                  placeholder=" "
                  v-model="userData.fbtBaseValue"
                />
                <label class="floatingLabel" for="fbtBaseValue"
                  >FBT Base Value</label
                >
                <div class="invalid-feedback" v-if="errors.fbtBaseValue">
                  {{ errors.fbtBaseValue[0] }}
                </div>
              </div>
            </div>
          </div>
          <div class="text-right">
            <button type="submit" class="btn btn-info btn-sm">Update</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import { states } from '../../../services/data.service'
import * as messageService from '../../../services/message.service'
import * as systemSettingsService from '../../../services/systemSettings.service'

export default {
  name: 'SystemSettings',
  components: {},

  data() {
    return {
      errors: {},
      loginUserObj: {},

      userData: {
        id: '',
        companyName: '',
        street: '',
        suburb: '',
        state: '',
        postCode: '',
        phoneNo: '',
        companyEmail: '',
        abn: '',
        vsaDefaultEmail: '',
        fbtBaseValue: ''
      },
      optionsStates: states
    }
  },
  methods: {
    fnGetSS: async function () {
      this.errors = {}

      try {
        let res = await systemSettingsService.single(1)
        Object.assign(this.userData, res.data)
      } catch (error) {
        switch (error.response.status) {
          case 422:
            this.errors = error.response.data.errors
            break

          case 500:
            messageService.fnSweetAlertErrorToast(
              'System settings - update',
              error.response.data.message
            )
            break

          default:
            messageService.fnSweetAlertErrorToast(
              'System settings - update',
              'Something wrong'
            )
            break
        }
      }
    },

    fnUpdate: async function () {
      this.errors = {}

      try {
        await systemSettingsService.update(this.userData.id, this.userData)
        messageService.fnSweetAlertSuccessToast(
          'System settings - Successfully updated'
        )
      } catch (error) {
        switch (error.response.status) {
          case 422:
            this.errors = error.response.data.errors
            break

          case 500:
            messageService.fnSweetAlertErrorToast(
              'System settings - update',
              error.response.data.message
            )
            break

          default:
            messageService.fnSweetAlertErrorToast(
              'System settings - update',
              'Something wrong'
            )
            break
        }
      }
    }
  },
  created() {
    this.fnGetSS()
  }
}
</script>
